import CryptoJS from "crypto-js";

export const validationFunction = (value) => {
  const bytes = CryptoJS.AES.decrypt(
    value,
    "ludobroToken65426545246t@&^%@^&^@%@%",
  );
  const decryptedData = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
  return decryptedData;
};

export const secureTokenFunction = (value) => {
  const dataString = CryptoJS.AES.encrypt(
    JSON.stringify(value),
    "ludobroToken65426545246t@&^%@^&^@%@%",
  ).toString();

  return dataString;
};
